import { ConsultationsProvider } from 'components/consultations/ConsultationsContext';
import { GuarantorsProvider } from 'components/guarantors/GuarantorsContext';
import { MandateProvider } from 'components/MandateContext';
import { MedicamentsProvider } from 'components/medicaments/MedicamentsContext';
import { PatientCentralContextProviderWrapper } from 'components/patient-entry/PatientCentralContext';
import { PatientProvider } from 'components/patient/PatientContext';
import { EntriesProvider } from 'components/segments/entires/EntriesContext';
import { SidebarProvider } from 'components/sidebar/SidebarContext';
import { TariffProvider } from 'components/tariffs/TariffContext';
import { TreatmentsProvider } from 'components/treatments/TreatmentsContext';
import { NotificationSystemProvider } from 'context/NotificationSysemContext';
import React from 'react';
import { UserNotificationProvider } from 'routes/UserNotificationsContext';

interface Props {
  children: JSX.Element | Array<JSX.Element>
}

const ProviderWrapper = (props: Props) => {
  return (
      <MandateProvider>
        <PatientProvider>
          <TreatmentsProvider>
            <ConsultationsProvider>
              <GuarantorsProvider>
                <PatientCentralContextProviderWrapper>
                  <SidebarProvider>
                    <MedicamentsProvider>
                      <TariffProvider>
                        <EntriesProvider>
                          <NotificationSystemProvider>
                            <UserNotificationProvider>
                              {props.children}
                            </UserNotificationProvider>
                          </NotificationSystemProvider>
                        </EntriesProvider>
                      </TariffProvider>
                    </MedicamentsProvider>
                  </SidebarProvider>
                </PatientCentralContextProviderWrapper>
              </GuarantorsProvider>
            </ConsultationsProvider>
          </TreatmentsProvider>
        </PatientProvider>
      </MandateProvider>
  );
};

export default ProviderWrapper;
